import { FLIGHT_TYPE } from '@/constants/common.constants';
import { useQuery } from './useQuery';
import _capitalize from 'lodash/capitalize';

export function useComputeSplitQueryAttrs(baseQuery?: string) {
  const {
    tripType,
    cabinType,
    adultCount,
    childCount,
    infantCount,
    totalPax,
    route,
    originId,
    destinationId,
    isDomesticKSA,
  } = useQuery(baseQuery);
  const attributes = {
    cabin_class: cabinType,
    adult_pax: adultCount,
    child_pax: childCount,
    infant_pax: infantCount,
    total_pax: totalPax,
    trip_type: _capitalize(tripType),
    flight_type: isDomesticKSA ? FLIGHT_TYPE.DOMESTIC : FLIGHT_TYPE.INTERNATIONAL,
    route,
    origin_iata: originId,
    destination_iata: destinationId,
  };

  return attributes;
}
